(function(){
  var STORAGE_KEY = 'bt_wishlist';

  function migrate(raw){
    if (!Array.isArray(raw)) return [];
    return raw.map(function(item){
      if (typeof item === 'string') return { handle: item, purchased: false };
      if (item && typeof item === 'object' && item.handle) return { handle: item.handle, purchased: !!item.purchased };
      return null;
    }).filter(Boolean);
  }

  function getWishlist(){
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? migrate(JSON.parse(raw)) : [];
    } catch(e) { return []; }
  }

  function saveWishlist(list){
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); } catch(e) {}
  }

  function findIndex(list, handle){
    for (var i=0;i<list.length;i++){ if (list[i].handle === handle) return i; }
    return -1;
  }

  function isSaved(handle){
    return findIndex(getWishlist(), handle) !== -1;
  }

  function toggle(handle){
    var list = getWishlist();
    var idx = findIndex(list, handle);
    if (idx === -1) { list.push({ handle: handle, purchased: false }); } else { list.splice(idx, 1); }
    saveWishlist(list);
    refreshHearts();
    updateCountBadges();
    document.dispatchEvent(new CustomEvent('bt:wishlist:updated', { detail: { list: list } }));
    return findIndex(list, handle) !== -1;
  }

  function togglePurchased(handle){
    var list = getWishlist();
    var idx = findIndex(list, handle);
    if (idx === -1) return;
    list[idx].purchased = !list[idx].purchased;
    saveWishlist(list);
    document.dispatchEvent(new CustomEvent('bt:wishlist:updated', { detail: { list: list } }));
    return list[idx].purchased;
  }

  function getShareUrl(){
    var list = getWishlist();
    var compact = list.map(function(item){ return { h: item.handle, p: item.purchased }; });
    var encoded = '';
    try { encoded = encodeURIComponent(btoa(JSON.stringify(compact))); } catch(e) { encoded = ''; }
    var base = window.location.origin + '/pages/wishlist';
    return encoded ? (base + '?share=' + encoded) : base;
  }

  function refreshHearts(){
    var list = getWishlist();
    document.querySelectorAll('.bt-wishlist-heart[data-handle]').forEach(function(btn){
      var handle = btn.getAttribute('data-handle');
      var active = findIndex(list, handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function updateCountBadges(){
    var count = getWishlist().length;
    document.querySelectorAll('.bt-wishlist-count').forEach(function(el){
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  document.addEventListener('click', function(e){
    var btn = e.target.closest('.bt-wishlist-heart');
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    toggle(handle);
  });

  document.addEventListener('DOMContentLoaded', function(){
    refreshHearts();
    updateCountBadges();
  });
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    refreshHearts();
    updateCountBadges();
  }

  window.BTWishlist = {
    getWishlist: getWishlist,
    isSaved: isSaved,
    toggle: toggle,
    togglePurchased: togglePurchased,
    getShareUrl: getShareUrl,
    refreshHearts: refreshHearts,
    updateCountBadges: updateCountBadges
  };
})();